/**
 * Form helper utilities
 */

/**
 * Scroll to and focus the first form field with an error.
 * Looks for elements with data-error="true" or aria-invalid="true".
 *
 * Useful for:
 * - Client-side validation errors (handled automatically by Form component)
 * - Server-side validation errors (call manually after setting form errors)
 */
export function scrollToFirstError() {
  // Small delay to allow DOM to update with error states
  setTimeout(() => {
    const firstError = document.querySelector('[data-error="true"], [aria-invalid="true"]')
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
      const input = firstError.querySelector('input, select, textarea') as HTMLElement | null
      input?.focus()
    }
  }, 100)
}
